import { render } from "./FileSimpleIcon.vue?vue&type=template&id=5749bb0e&ts=true"
import script from "./FileSimpleIcon.vue?vue&type=script&lang=ts"
export * from "./FileSimpleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__